import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { environment } from '@environments/environment';
import { DataService } from '@app/_services/data.service';
import { Department } from '@app/_models/_DTOs/department';

@Injectable({ providedIn: 'root' })
export class DepartmentService extends DataService<Department> {
    constructor(http: HttpClient) {
        super(http, "api/departments")
    }
}